// Utility for obfuscating the discount code parameter name and value in the URL.
// Both the parameter name and value are XOR-encrypted with a secret key and hex-encoded.
// This makes it very difficult to recover the original values from the URL without knowing the key.
// This is not cryptographically secure, but is sufficient to prevent casual inspection or simple decoding.
// Update SECRET_KEY to something unique for your project if needed.
//
// Usage:
//   encode(str) - obfuscates a string for use in the URL
//   decode(hex) - recovers the original string from the obfuscated value
//   OBFUSCATED_PARAM - the obfuscated parameter name for use in query strings
//   getDiscountCodeSearchParam(location) - retrieves the discount code from the URL
//   setDiscountCodeSearchParam(location, discountCode) - sets the obfuscated code in the URL
//
// Note: This is for obfuscation only, not for strong security.

const SECRET_KEY = 'boczelli';

function xorEncrypt(str, key) {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    result += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
  }
  return result;
}

function toHex(str) {
  return Array.from(str)
    .map(c =>
      c
        .charCodeAt(0)
        .toString(16)
        .padStart(2, '0')
    )
    .join('');
}

function fromHex(hex) {
  let str = '';
  for (let i = 0; i < hex.length; i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return str;
}

const encode = str => {
  if (!str) return '';
  return toHex(xorEncrypt(str, SECRET_KEY));
};

const decode = hex => {
  if (!hex) return '';
  try {
    return xorEncrypt(fromHex(hex), SECRET_KEY);
  } catch (e) {
    return '';
  }
};

const DISCOUNT_CODE_PARAM = 'userTryOnDiscountCode';
const OBFUSCATED_PARAM = encode(DISCOUNT_CODE_PARAM);

export const getDiscountCodeSearchParam = location => {
  const params = new URLSearchParams(location.search);
  const obfuscatedValue = params.get(OBFUSCATED_PARAM);
  if (obfuscatedValue) {
    const decoded = decode(obfuscatedValue);
    return decoded ? { userTryOnDiscountCode: decoded } : {};
  }
  return {};
};

export const setDiscountCodeSearchParam = (location, discountCode) => {
  const params = new URLSearchParams(location.search);
  if (discountCode) {
    params.set(OBFUSCATED_PARAM, encode(discountCode));
  } else {
    params.delete(OBFUSCATED_PARAM);
  }
  return `${location.pathname}?${params.toString()}`;
};
